// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_TZN","cls2":"ReferenceEvaluationPage-cls2_TJ6 ReferenceEvaluationPage-cls1_TZN"};